import React, { Component } from 'react';
import {
    Container,
    Row,
    Col,
    Input,
    Button,
    Table,
    Spinner,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import './layout/site.css'
import AuthFunctions from './services/AuthService';
import Session from './auth/Session';
import isEmpty from './util/isEmpty';

const queryParams = new URLSearchParams(window.location.search);
const fileNumber = queryParams.get("file");

export class FileDetails extends Component {
    static displayName = FileDetails.name;
    constructor(props) {
        super(props);
        this.checkAuthenticated();

        this.state = {
            search: null,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            showLoading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 10,
            numberOfPages: 0,
            fileChosen: false,
            modalOpen: false,
            file: [],
            fileNumber: fileNumber,
            chosenReport: "",
            budgetDetails: {},
            dropDownOpen: false,
            drawNumber: '',
            format: 'PDF',
            reportError: null,

            // NEW
            isAdmin: false,
        };
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async componentDidMount() {
        this.selectFile();
        this.getBudget();

        // NEW: determine admin once (fail-closed)
        try {
            const isAdmin = await AuthFunctions.isAdminAsync();
            this.setState({ isAdmin: isAdmin === true });
        } catch {
            this.setState({ isAdmin: false });
        }
    }

    render() {

        document.title = "File Details - QDraw, Inc.";

        const currentItems = this.state.file;

        // Used to format the money strings
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        const renderItems = currentItems.map((file, i) => {

            const budget = formatter.format(Number(file.originalOwnerFinancing) + Number(file.originalConstructionLoanAmount));

            return (
                <div key={i}>
                    <p><strong>Owner Name:</strong> <br />{file.propertyOwner}</p>
                    <p><strong>General Contractor Name:</strong> <br />{file.generalContractor}</p>
                    <p><strong>Lender Name:</strong> <br />{file.lender}</p>
                    <p><strong>Project Budget:</strong><br /> {formatter.format(this.state.budgetDetails.totalBudget)}</p>
                    <p style={{ paddingLeft: '25px' }}><strong>Owner Funding:</strong> <br />{formatter.format(this.state.budgetDetails.ownerFunding)}</p>
                    <p style={{ paddingLeft: '25px' }}><strong>Lender Funding:</strong> <br />{formatter.format(this.state.budgetDetails.lenderFunding)}</p>
                    <p><strong>Funds Disbursed to Date:</strong> <br /> {formatter.format(this.state.budgetDetails.fundsDisbursed)}</p>
                    <p><strong>Remaining Budget:</strong> <br /> {formatter.format(this.state.budgetDetails.remainingBudget)}</p>
                    <p><strong>Current Funds in Escrow:</strong> <br /> {formatter.format(this.state.budgetDetails.fundsInEscrow)}</p>
                </div>
            )
        });

        const renderAddress = currentItems.map((file, i) => {
            return (
                <span key={i} style={{ marginLeft: '20px' }}>
                    {file.propertyStreetAddress}, {file.propertyCity}, {file.propertyState} {file.propertyZip === 0 ? "" : file.propertyZip}
                </span>
            )
        });

        const toggle = () => {
            this.setState({ dropDownOpen: !this.state.dropDownOpen })
        }

        const formatChange = (event) => {
            console.log('Selected item: ', event.currentTarget.textContent);
            this.setState({ format: event.currentTarget.textContent });
        }

        const getReport = async (report) => {
            this.setState({ loading: true, showLoading: true, loadingDocument: true });

            const token = Session.getToken();
            const fileNumber = this.state.fileNumber;
            const reportName = report === null ? this.state.chosenReport : report;
            const format = this.state.format;

            // NEW: enforce drawNumber rules
            // - Only RetentionReport uses drawNumber
            // - Admin: use UI value (or 0 if blank)
            // - Non-admin: force 0
            let drawNumber = this.state.drawNumber;
            if (reportName === "RetentionReport") {
                if (this.state.isAdmin === true) {
                    drawNumber = (drawNumber && drawNumber.trim().length > 0) ? drawNumber : "0";
                } else {
                    drawNumber = "0";
                }
            } else {
                // Keep old behavior for other reports (still safe even if included)
                drawNumber = "";
            }

            fetch(`api/Files/RunReport?fileNumber=${encodeURIComponent(fileNumber)}&drawNumber=${encodeURIComponent(drawNumber)}&reportName=${encodeURIComponent(reportName)}&format=${encodeURIComponent(format)}`, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            }).then((res) => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.blob();
            })
                .then((blob) => {
                    const href = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = href;
                    link.target = "_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.setState({ loading: false, showLoading: false, loadingDocument: false, reportError: null });
                })
                .catch((err) => {
                    this.setState({ loading: false, showLoading: false, loadingDocument: false, reportError: 'The report could not be generated!' });
                })
        }

        return (
            <Container>
                <Row style={{ marginTop: '20px' }}>
                    <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                        <p style={{ textAlign: 'center' }}>
                            <span>File #{this.state.fileNumber}</span>
                            <span>{renderAddress}</span>
                        </p>
                    </Col>
                </Row>

                <Row style={{ marginTop: '20px' }}>
                    <Col xl='4' lg='4' md='4' sm='12' xs='12'>
                        {this.state.reportError !== null && (
                            <div style={{ color: 'red', fontWeight: 'bold', fontSize: '16px' }}>
                                {this.state.reportError}
                            </div>
                        )}
                        {renderItems}
                    </Col>
                    <Col xl='4' lg='4' md='4' sm='12' xs='12'>
                        <Button
                            color='primary'
                            onClick={() => { this.setState({ modalOpen: false }); this.setState({ chosenReport: "ProjectSummaryReport" }); getReport("ProjectSummaryReport"); }}
                            style={{ marginTop: '10px', width: '230px' }}
                            disabled={this.state.loading ? true : false}
                        >
                            Project Summary Report
                        </Button>
                        <br />
                        <Button
                            color='primary'
                            onClick={() => {
                                // NEW:
                                // - Admin: open modal to ask Draw #
                                // - Non-admin: run immediately with drawNumber forced to 0
                                if (this.state.isAdmin === true) {
                                    this.setState({ modalOpen: true });
                                    this.setState({ chosenReport: "RetentionReport" });
                                } else {
                                    this.setState(
                                        { modalOpen: false, chosenReport: "RetentionReport", drawNumber: "0" },
                                        () => getReport("RetentionReport")
                                    );                                }
                            }}
                            style={{ marginTop: '10px', width: '230px' }}
                            disabled={this.state.loading ? true : false}
                        >
                            Retention Report
                        </Button>
                        <br />
                        <Button
                            color='primary'
                            onClick={() => { this.setState({ modalOpen: false }); this.setState({ chosenReport: "MultiSourceFundingReport" }); getReport("MultiSourceFundingReport"); }}
                            style={{ marginTop: '10px', width: '230px' }}
                            disabled={this.state.loading ? true : false}
                        >
                            Multi Source Funding Report
                        </Button>
                        <br />
                        <Button
                            color='primary'
                            onClick={() => { this.setState({ modalOpen: false }); this.setState({ chosenReport: "DrawbyDrawReport" }); getReport("DrawbyDrawReport"); }}
                            style={{ marginTop: '10px', width: '230px' }}
                            disabled={this.state.loading ? true : false}
                        >
                            Draw by Draw Report
                        </Button>
                        <br />
                        <Button
                            color='primary'
                            onClick={() => { this.setState({ modalOpen: false }); this.setState({ chosenReport: "CheckRegisterReport" }); getReport("CheckRegisterReport"); }}
                            style={{ marginTop: '10px', width: '230px' }}
                            disabled={this.state.loading ? true : false}
                        >
                            Check Register Report
                        </Button>
                    </Col>
                    <Col xl='4' lg='4' md='4' sm='12' xs='12'>
                        <div
                            id="myModal"
                            className="modal"
                            style={this.state.modalOpen === false ? { display: 'none' } : { display: 'block' }}
                        >
                            <div className="modal-content">
                                <Row style={{ marginLeft: 0, marginBottom: 5, textAlign: 'right' }}>
                                    <div style={{ width: '100%', right: 0, marginRight: '20px', marginTop: '-10px' }}>
                                        <span
                                            className="close"
                                            onClick={() => this.setState({ modalOpen: false })}
                                        >
                                            &times;
                                        </span>
                                    </div>
                                </Row>

                                {/* Draw # input ONLY for Admin + only for RetentionReport */}
                                <Row style={(this.state.chosenReport !== "RetentionReport" || this.state.isAdmin !== true) ? { display: 'none', marginLeft: 0, marginBottom: 5 } : { marginLeft: 0, marginBottom: 10, marginRight: 10 }}>
                                    <span>
                                        Draw #
                                    </span>
                                    <Input
                                        type=''
                                        onChange={(e) => this.setState({ drawNumber: e.target.value })}
                                        name='drawNum'
                                        id='drawNum'
                                        onKeyPress={this.handleKeyPress}
                                        placeholder=''
                                    />
                                </Row>

                                <Row style={{ marginLeft: 0, display: 'none' }}>
                                    <Dropdown isOpen={this.state.dropDownOpen} toggle={toggle}>
                                        <DropdownToggle caret>Export As...</DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem onClick={formatChange}>PDF</DropdownItem>
                                            <DropdownItem onClick={formatChange}>XLSX</DropdownItem>
                                            <DropdownItem onClick={formatChange}>DOCX</DropdownItem>
                                            <DropdownItem onClick={formatChange}>CSV</DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                    <span style={{ marginLeft: 10, verticalAlign: 'center' }}>{this.state.format}</span>
                                </Row>
                                <Button
                                    color='primary'
                                    onClick={() => getReport("RetentionReport")}
                                    style={{ marginTop: '10px', width: '230px' }}
                                    disabled={this.state.loading ? true : false}
                                >
                                    Run Report
                                </Button>
                            </div>
                        </div>
                        <div
                            id="loadingModal"
                            className="modal"
                            style={this.state.loading === false ? { display: 'none' } : { display: 'block' }}
                        >
                            <div className="modal-content">
                                <Row style={{ textAlign: 'center', width: '100%' }}>
                                    <Col className="col-sm-auto">
                                        <Spinner style={{ marginLeft: 20, marginRight: 20 }}></Spinner>
                                    </Col>
                                    <Col>
                                        <div style={{ display: 'inline-block', height: '100%', alignContent: 'center', textAlign: 'center' }} >Loading, please wait.</div>
                                    </Col>
                                    <Col className="col-sm-auto">
                                        <span
                                            className="close"
                                            onClick={() => this.setState({ showLoading: false })}
                                        >
                                            &times;
                                        </span>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }

    async selectFile() {
        this.setState({ loading: true, showLoading: true, loadingDocument: false });

        const fileNumber = this.state.fileNumber;
        const token = Session.getToken();

        const response = await fetch(`api/Files/SelectFile?fileNumber=${encodeURIComponent(fileNumber)}`,
            {
                headers: !token ? {} : { Authorization: `Bearer ${token}` }
            });

        if (!response.ok) {
            this.setState({ loading: false, showLoading: false });
            return;
        }

        const data = await response.json();
        this.setState({ file: data, loading: false, showLoading: false, noResults: isEmpty(data) });
    }

    async getBudget() {
        this.setState({ loading: true, showLoading: true, loadingDocument: false });

        const token = Session.getToken();
        const fileNumber = this.state.fileNumber;

        const response = await fetch(`api/Files/GetBudget?fileNumber=${encodeURIComponent(fileNumber)}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        if (!response.ok) {
            this.setState({ loading: false, showLoading: false, noResults: true, error: true });
            return;
        }

        const data = await response.json();

        this.setState({ budgetDetails: data, loading: false, showLoading: false, noResults: isEmpty(data) });
    }
}